import { createStyles } from '@material-ui/core';

export default () =>
  createStyles({
    sliderRoot: { padding: 10 },
    labelContainer: { display: 'flex', height: 21 },
    leftContainer: {
      display: 'grid',
      alignItems: 'center',
    },

    fullWidth: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
    title: {
      fontWeight: 900,
    },

    blankCard: {
      boxShadow: '0 2px 4px 0 rgb(0 0 0 / 40%)',
    },
    input: {
      '& .MuiOutlinedInput-inputMultiline': {
        minHeight: 160,
      },
    },
  });
